'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import GreaterRolling from 'customer-data-filters/filterQueryFormat/operator/GreaterRolling';
import I18n from 'I18n';
import LessRolling from 'customer-data-filters/filterQueryFormat/operator/LessRolling';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UISelect from 'UIComponents/input/UISelect';
import isNumber from 'transmute/isNumber';
import { hasNewIlsTimeFiltersEnabled, hasRemoveTimezoneForDates } from '../../permissions/gates';
import TimezoneToggle from './TimezoneToggle';
import UpdateDateFilterWithTimezonesNotification from './UpdateDateFilterWithTimezonesNotification';
import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class FilterOperatorRollingInequalityInput extends PureComponent {
  constructor(props) {
    super(props);
    this.handleUpdateClick = () => {
      const {
        condition,
        value,
        onChange
      } = this.props;
      this.setState({
        useUTC: false
      });
      this.setState({
        showTimezoneToggle: false
      });
      if (!condition || !value) {
        return;
      }
      onChange(SyntheticEvent(value.set('zoneId', I18n.moment.portalTz().tz())), {
        hasClickedUpdate: true
      });
    };
    this.handleChangeTimezone = useUTC => {
      const {
        onChange,
        value
      } = this.props;
      this.setState({
        useUTC
      });
      onChange(SyntheticEvent(value.set('zoneId', useUTC ? 'UTC' : I18n.moment.portalTz().tz())));
    };
    this.handleChangeDirection = ({
      target: {
        value: direction
      }
    }) => {
      const {
        onChange,
        value
      } = this.props;
      onChange(SyntheticEvent(value.set('direction', direction)));
    };
    this.handleChangeNumberOfDays = ({
      target: {
        value: days
      }
    }) => {
      const {
        onChange,
        value
      } = this.props;
      this.setState({
        error: false
      });
      onChange(SyntheticEvent(value.set('numberOfDays', days)));
    };
    this.handleCommit = value => {
      if (!isNumber(value)) {
        this.setState({
          error: true
        });
      }
      return value ? `${value}` : null;
    };
    const {
      getDefaultTimezone,
      getIsUngated,
      isNotUsingTimePoints,
      onChange: _onChange,
      value: _value,
      condition: _condition
    } = props;
    const {
      hasTimezones
    } = _condition;
    const defaultTimezone = hasRemoveTimezoneForDates(getIsUngated) && !hasTimezones ? I18n.moment.portalTz().tz() : getDefaultTimezone(_value.field);
    const zoneId = _value.zoneId || defaultTimezone;
    this.state = {
      error: false,
      useUTC: zoneId === 'UTC',
      showTimezoneToggle: true
    };
    if (hasNewIlsTimeFiltersEnabled(getIsUngated) && !isNotUsingTimePoints && defaultTimezone && !_value.zoneId) {
      _onChange(SyntheticEvent(_value.set('zoneId', defaultTimezone)));
    }
  }
  componentDidMount() {
    this.setShowTimezoneToggle();
  }
  componentDidUpdate() {
    this.setShowTimezoneToggle();
  }
  setShowTimezoneToggle() {
    const {
      condition,
      getIsUngated,
      value
    } = this.props;
    const {
      hasTimezones
    } = condition;
    const isDateTimeOperator = value.field && value.field.type === DATE_TIME;
    if (hasRemoveTimezoneForDates(getIsUngated) && !isDateTimeOperator && !hasTimezones && (condition.constructor === GreaterRolling || condition.constructor === LessRolling)) {
      this.setState({
        showTimezoneToggle: false
      });
    } else {
      this.setState({
        showTimezoneToggle: true
      });
    }
  }
  render() {
    const {
      className,
      value,
      getIsUngated,
      isNotUsingTimePoints
    } = this.props;
    const {
      useUTC,
      error,
      showTimezoneToggle
    } = this.state;
    const isDateTimeOperator = value.field && value.field.type === DATE_TIME;
    const options = [{
      text: I18n.text('customerDataFilters.FilterOperatorRollingInequalityInput.daysAgo', {
        count: value.numberOfDays || 0
      }),
      value: 'backward'
    }, {
      text: I18n.text('customerDataFilters.FilterOperatorRollingInequalityInput.daysFromNow', {
        count: value.numberOfDays || 0
      }),
      value: 'forward'
    }];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UIInputGroup, {
        className: className,
        use: "itemRight",
        children: [/*#__PURE__*/_jsx(UIFormControl, {
          error: error,
          validationMessage: error ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorRollingInequalityInput.error"
          }) : null,
          children: /*#__PURE__*/_jsx(UINumberInput, {
            defaultValue: 1,
            formatter: this.handleCommit,
            min: 0,
            onChange: this.handleChangeNumberOfDays,
            value: value.numberOfDays
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(UISelect, {
            buttonUse: "transparent",
            onChange: this.handleChangeDirection,
            options: options,
            value: value.direction
          })
        })]
      }), showTimezoneToggle && value.zoneId && /*#__PURE__*/_jsx(TimezoneToggle, {
        fieldType: value.field ? value.field.get('type') : undefined,
        getIsUngated: getIsUngated,
        isNotUsingTimePoints: isNotUsingTimePoints,
        onChange: this.handleChangeTimezone,
        useUTC: useUTC
      }), hasRemoveTimezoneForDates(getIsUngated) && showTimezoneToggle && !isNotUsingTimePoints && !isDateTimeOperator && /*#__PURE__*/_jsx(UpdateDateFilterWithTimezonesNotification, {
        onUpdateClick: this.handleUpdateClick,
        useUTC: useUTC
      })]
    });
  }
}
FilterOperatorRollingInequalityInput.propTypes = {
  className: PropTypes.string,
  condition: PropTypes.oneOfType([PropTypes.instanceOf(GreaterRolling).isRequired, PropTypes.instanceOf(LessRolling).isRequired]).isRequired,
  getDefaultTimezone: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  isNotUsingTimePoints: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.instanceOf(GreaterRolling).isRequired, PropTypes.instanceOf(LessRolling).isRequired]).isRequired
};
export default FilterOperatorRollingInequalityInput;